import $ from 'jquery';
import Constants from 'Constants'
import BasePropertyView from 'BasePropertyView';
import listService from 'ListService';
import Immutable from 'immutable';
import contentTemplate from 'behaviors/properties/main/notify/edit-notification-general.ejs';
import util from 'util/Util';

class EditNotificationGeneralView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};

        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = '#editNotificationGeneral';
        this.factoryKey = opts.factoryKey;
        this.table = Constants.PROP_MAIN_TABLE_NOTIFICATION_VIEW;

        this.roles = [{ name: 'Unspecified', id: ''}];
        this.loadRoles();

        this.model.set('roleOpts', this.roles, {silent:true});
        this.model.set('attLevelOpts', ['No attention needed', 'Normal attention needed','High attention needed',
            'Urgent attention needed', 'Very urgent attention needed', 'Extremely urgent attention needed'], {silent:true});

        if (this.factoryKey === undefined) {
            this.factoryKey = this.model.attributes.factoryKey;
        }
        if (!this.model.get('notificationTitle')) {
            this.model.set('notificationTitle', '', {silent: true})
        }

        this.events = {
            'change #notificationTitle'                : 'updateTitle',
            'blur input[type=text]'                    : 'lostFocus',
            'focus input[type=text]'                   : 'getFocus',
            'change #attentionLevel, #notificationRol' : 'updateSelectAttributes'
        };

        this.listenTo(this.model, 'change', this.render);

        // Don't change this name without realizing that the base class may assume this name
        this.dropdownPropNames = Immutable.List(
            ['attentionLevel', 'notificationRolId']); 

        return this;
    }

    loadRoles() {
        var roles = listService.getWorkflowRoles(false);
        roles.map((role)=> {
           this.roles.push(role);
        });
    }

    updateTitle(ev) {
        ev.preventDefault();
        const propVal  =  util.sanitizeHTML(ev.currentTarget.value, true, this.model.get('notificationTitle'));;
        this.model.set('notificationTitle', propVal, {silent: true});
        this.updateGrid('title', propVal);
    }

    updateSelectAttributes(ev) {
        ev.preventDefault();
        const propName  = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        let value = '';
        if (propName === 'attentionLevel') {
            value = this.model.get('attLevelOpts')[propVal];
            this.updateGrid('attentionLevelText', value);
            this.updateGrid('attentionLevel', propVal);
            this.model.set('attentionLevel', propVal);
        }else {
            //value = this.model.get('roleOpts')[propVal];

            var selectedObject = $.grep(this.model.get('roleOpts'), function (e) { return e.id === propVal; });

            this.updateGrid('role', selectedObject[0].name);
            this.updateGrid('roleId', propVal);
            if (selectedObject[0].defaultPerson) {
                this.updateGrid('person',selectedObject[0].defaultPerson)
            }
            this.model.set('notificationRol', selectedObject[0].name);
            this.model.set('notificationRolId', propVal);
        } 
    }

    updateGrid(field, value) {
        let id = $(this.table).getGridParam('selrow');
        let rowData = $(this.table).getRowData(id);
        rowData[field] = value;
        $(this.table).setRowData(id, rowData);
    }

    render() {
        this.$el.empty(); 
        if (this.model.get('notificationRolId') === undefined) {
          this.model.set('notificationRolId', 0);  
        } 

        this.$el.html(this.template(this.model.toJSON()));

        this.updateForm();
        return this;

    }
}

export default EditNotificationGeneralView;
